import React from 'react';
import useMedia from '../../../hooks/useMedia'

interface SkeletonCardsProps {
  columns?: number;
  rows?: number;
}

export const SkeletonCards: React.FC<SkeletonCardsProps> = ({ columns = 4, rows = 4 }) => {
  const { isSmall } = useMedia();

  const skeletonCards = [];

  const numColumns = isSmall ? 2 : columns;
  const numRows = isSmall ? 2 : rows;

  for (let i = 0; i < numColumns * numRows; i++) {
    skeletonCards.push(
      <div key={i} className="cards-skeleton"></div>
    );
  }

  let cardColumns = 2;

  if (window.innerWidth > 768) {
    cardColumns = 4;
  }

  return (
    <div style={{display: 'grid', gap: '4px', gridTemplateColumns: `repeat(${cardColumns}, minmax(200px, 1fr))`}}>
      {skeletonCards}
    </div>
  );
};

